import React from 'react'
import styled from 'styled-components'
import mediaQuery from 'styles/mediaQuery'
import colors from 'styles/colors'
import { Link } from 'gatsby'
import AppleButtonIcon from '../images/apple.svg'
import GoogleButtonIcon from '../images/google.svg'

const LinksColumn = styled.div`
  margin-bottom: 5px;

  ${mediaQuery.bigTabletMin} {
    &:nth-child(1) {
      flex: 0 0 30%;
    }

    &:nth-child(2) {
      flex: 0 0 33%;
    }

    &:nth-child(3) {
      flex: 1 1 18%;
    }

    &:nth-child(4) {
      flex: 0 0 auto;
    }
  }

  ${mediaQuery.tablet} {
    flex: 0 0 50%;
  }

  ${mediaQuery.mobile} {
    flex: 0 0 100%;
  }
`

const ButtonsColumn = styled.div`
  flex: 0 0 auto;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;

  ${mediaQuery.mobile} {
    position: absolute;
    top: 0;
    right: 0;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  position: relative;

  ${mediaQuery.tabletMax} {
    flex-wrap: wrap;
  }

  ${mediaQuery.mobile} {
    margin-bottom: 0;
  }

  & > * {
    min-width: 0;
  }
`

const LinkStyled = styled(Link)`
  color: ${colors.textBlack};
  white-space: nowrap;
  flex: 0 0 auto;
  line-height: 1.6;
  display: block;
  font-size: 18px;
  padding-right: 30px;
  font-weight: 500;

  &,
  &:hover,
  &:focus {
    text-decoration: none;
  }
  ${mediaQuery.tabletMin} {
    min-width: 200px;
  }
  ${mediaQuery.mobile} {
    margin-right: 20px;
    font-size: 12px;
  }
`

const LinkTitle = styled.span`
  display: block;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
  letter-spacing: 0.03em;
  line-height: 30px;
  text-transform: uppercase;

  ${mediaQuery.mobile} {
    font-size: 12px;
    margin-bottom: 5px;
  }
`

const LinksList = styled.div`
  margin-bottom: 15px;
`

const StoreLink = styled.a`
  display: inline-block;

  &:first-child {
    margin-bottom: 8px;
  }
`

const AppleButton = styled(AppleButtonIcon)`
  width: 150px;

  ${mediaQuery.mobile} {
    width: 90px;
  }
`
const GoogleButton = styled(GoogleButtonIcon)`
  width: 150px;

  ${mediaQuery.mobile} {
    width: 90px;
  }
`

const FooterLinks = () => (
  <>
    <Row>
      <LinksColumn>
        <LinkTitle>HELP</LinkTitle>
        <LinksList>
          <LinkStyled
            as="a"
            href="https://help.flip.shop/about-us/"
            aria-label="Frequently Asked Questions"
            rel="noopener noreferrer nofollow"
          >
            FAQ
          </LinkStyled>
          <LinkStyled to="/contact" aria-label="Contact page">
            Contact
          </LinkStyled>
        </LinksList>
      </LinksColumn>
      <LinksColumn>
        <LinkTitle>SELL ON FLIP</LinkTitle>
        <LinksList>
          <LinkStyled to="/sellwithflip" aria-label="Start selling on Flip">
            Start selling on Flip
          </LinkStyled>
        </LinksList>
      </LinksColumn>
      <LinksColumn>
        <LinkTitle>CONNECT</LinkTitle>
        <LinksList>
          <LinkStyled
            as="a"
            href="https://www.instagram.com/joinflip/"
            aria-label="Instagram"
            rel="noopener noreferrer nofollow"
          >
            Instagram
          </LinkStyled>
          <LinkStyled
            as="a"
            href="https://www.tiktok.com/@joinflip"
            aria-label="TikTok"
            rel="noopener noreferrer nofollow"
          >
            TikTok
          </LinkStyled>
          <LinkStyled
            as="a"
            href="https://www.linkedin.com/company/myflipfit"
            aria-label="Linkedin"
            rel="noopener noreferrer nofollow"
          >
            Linkedin
          </LinkStyled>
        </LinksList>
      </LinksColumn>
      <ButtonsColumn>
        <StoreLink href="https://apps.apple.com/pl/app/flip-fit-live-shopping/id1470077137">
          <AppleButton />
        </StoreLink>
        <StoreLink href="https://play.google.com/store/apps/details?id=com.flipfit">
          <GoogleButton />
        </StoreLink>
      </ButtonsColumn>
    </Row>
    <Row>
      <LinksColumn>
        <LinkTitle>LEGAL</LinkTitle>
        <LinksList>
          <LinkStyled
            as="a"
            href="https://flip.shop/privacy"
            aria-label="Privacy Policy Page"
            rel="noopener noreferrer nofollow"
          >
            Privacy Policy
          </LinkStyled>
          <LinkStyled
            as="a"
            href="https://flip.shop/terms"
            aria-label="Terms & Conditions Page"
            rel="noopener noreferrer nofollow"
          >
            Terms & Conditions
          </LinkStyled>
        </LinksList>
      </LinksColumn>
      <LinksColumn>
        <LinkTitle>Join the Creator Community</LinkTitle>
        <LinksList>
          <LinkStyled
            to="https://flip.shop/lp/become-a-content-creator-on-flip"
            aria-label="Join Flip Ambassador program"
          >
            Become a Content Creator on Flip
          </LinkStyled>
        </LinksList>
      </LinksColumn>
    </Row>
  </>
)

export default FooterLinks
